import { PayoutTransactionDetailParameters, useRepositoryQuery } from '@mews-commander/data-access';

export const useGetPayoutTransactionsDetail = ({ transactionId }: PayoutTransactionDetailParameters) =>
    useRepositoryQuery('payoutTransactions', 'getDetail', { transactionId });
